import * as React from 'react';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import styled from '@emotion/styled';
import { Colors } from '../../../colors';
import { TooltipStyled } from './tooltip.styled';

export interface CustomTooltipProps extends TooltipProps{
  placement: 'right' | 'top' | 'bottom' | 'left'
  title: string
  description?: string[]
  arrow?: boolean
}

const CustomTooltip = styled(({ className, ...props }: CustomTooltipProps) => (
  <Tooltip {...props} title={ <TooltipStyled.ContainerTooltip>
    <TooltipStyled.TitleTooltip>
      {props.title}
    </TooltipStyled.TitleTooltip>
    {props.description &&
    <TooltipStyled.DescriptionTooltipContainer>
      {props.description.map(text =>
        <TooltipStyled.DescriptionTooltipText>
          {text}
        </TooltipStyled.DescriptionTooltipText>
      )}
    </TooltipStyled.DescriptionTooltipContainer>
    }
  </TooltipStyled.ContainerTooltip>} placement={props.placement} arrow={props.arrow} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: Colors.White,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: Colors.White,
    boxShadow: '0 0 30px 0 rgba(0, 0, 0, 0.2)',
  },
}));

export default CustomTooltip;
